import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'

export function PointsSkeleton() {
  return (
    <div className="flex h-full flex-col gap-6">
      <div className="flex flex-row gap-6">
        <Skeleton className="h-56 w-1/2" />
        <Skeleton className="h-56 w-1/2" />
      </div>
      <div className="flex flex-row gap-6">
        <Skeleton className="h-80 w-2/3" />
        <Skeleton className="h-80 w-1/3" />
      </div>
    </div>
  )
}
